module.exports = __webpack_public_path__ + "static/media/LP_ReadMore.7c12621d.svg";